/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { ThemeConfig, theme } from 'antd';
import { AliasToken } from 'antd/es/theme/internal';
import colors from './colors';

const { getDesignToken } = theme;

const token = {
  ...colors,
  borderRadius: 4,
  fontFamily: 'Nunito'
};

export const globalToken = getDesignToken({ token });

export const themeConfig: ThemeConfig = {
  // https://ant.design/theme-editor for more theme customizations
  token,
  components: {
    Layout: {
      bodyBg: colors.bodyBg
    },
    Typography: {
      titleMarginTop: 0,
      titleMarginBottom: 0,
      margin: 0
    },
    Button: {
      defaultBorderColor: colors.defaultBorderColor,
      colorLink: globalToken.colorPrimary,
      colorText: colors.colorText, // make slightly lighter than the base text color
      colorTextBase: colors.colorTextBase
    }
  },
  algorithm: theme.defaultAlgorithm
};

export const globalTokenLess = Object.keys(globalToken).reduce((acc, key) => {
  acc[`@${key}`] = globalToken[key as keyof AliasToken] as string;
  return acc;
}, {} as Record<string, string>);
